/* eslint-disable @next/next/next-script-for-ga */
// pages/_app.js
import React from 'react'
import Head from 'next/head'
import 'tailwindcss/tailwind.css'
import useAmplitude from '../hooks/useAmplitude'
import useTrackPageView from '../hooks/useTrackPageView'
import Analytics from '../components/Analytics'

// eslint-disable-next-line react/prop-types
function MyApp({ Component, pageProps }) {
  // eslint-disable-next-line react/prop-types
  const getLayout = Component.getLayout || ((page) => page)
  const { logEvent } = useAmplitude()
  useTrackPageView({ logEvent })

  return getLayout(
    <>
      <Head>
        {process.env.NODE_ENV !== 'development' && (
          <>
            <script
              async
              src="https://googletagmanager.com/gtag/js?id=G-SZ2FGMQ8Q4"
            />
            <script
              dangerouslySetInnerHTML={{
                __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                })(window,document,'script','dataLayer','GTM-MVTCZTV');`,
              }}></script>
          </>
        )}
      </Head>
      <Component {...pageProps} />
      {process.env.NODE_ENV !== 'development' && <Analytics />}
    </>,
  )
}

export default MyApp
